import { Component, OnInit } from '@angular/core';
import { ICountry } from '../../../core/models/country.interface';
import { ConstantService } from '../../../core/services/constant.service';
import { PartnerService } from '../../../modules/partner-management/services/partner.service';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BatchService } from '../../../modules/batch/service/batch.service';
import { NotificationService } from '../../../core/services/notification.service';
import { SaleOrderStatus } from '../../../../app/shared/enums/sale-order-status.enum';


@Component({
  selector: 'eci-create-batch-popup',
  templateUrl: './create-batch-popup.component.html',
  styleUrls: ['./create-batch-popup.component.scss']
})
export class CreateBatchPopupComponent implements OnInit {
  batchForm!: FormGroup;
  validate = false;

  createBatch : true;
  theSelectedSaleOrders : any;

  showLoader: boolean = false;

  originSearchCountry: FormControl = new FormControl('');
  destinationSearchCountry: FormControl = new FormControl('');
  searchPartner: FormControl = new FormControl('');

  availableOriginCountries: ICountry[] = [];
  availableDestinationCountries: ICountry[] = [];
  fullCountriesList: ICountry[] = [];
  partnerList: any[] = []; // Ensure proper typing

  constructor(
    private constSvc: ConstantService,
    private partnerService: PartnerService,
    private dialogRef: MatDialogRef<CreateBatchPopupComponent>,
    private formBuilder: FormBuilder,
    private batchService: BatchService,
    private notify: NotificationService,
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.getListOfCountries();
    this.getpartnerList();
    
    this.originSearchCountry.valueChanges.subscribe(value => {
      this.filterOriginCountries(value);
    });

    this.destinationSearchCountry.valueChanges.subscribe(value => {
      this.filterDestinationCountries(value);
    });

    this.constSvc.getAvailableCountries().subscribe(data => {
      this.fullCountriesList = data;
      this.availableOriginCountries = data;
      this.availableDestinationCountries = data;
    });
  }

  initializeForm() {
    this.batchForm = this.formBuilder.group({
      partner: ['', Validators.required],
      originCountry: ['', Validators.required],
      destinationCountry: [''],
    });
  }

  getListOfCountries() {
    this.constSvc.getAvailableCountriesForScroll(1, 1000, false, '').subscribe(data => {
      if (!data) return;
      this.fullCountriesList = data.items;
      this.availableOriginCountries = data.items;
      this.availableDestinationCountries = data.items;
    });
  }

  getpartnerList() {
    this.partnerService.getPartnersList().subscribe(result => {
      this.partnerList = result;
    });
  }

  filterOriginCountries(value: string) {
    this.availableOriginCountries = value
      ? this.fullCountriesList.filter(c => c.name.toLowerCase().includes(value.toLowerCase()))
      : this.fullCountriesList;
  }

  filterDestinationCountries(value: string) {
    this.availableDestinationCountries = value
      ? this.fullCountriesList.filter(c => c.name.toLowerCase().includes(value.toLowerCase()))
      : this.fullCountriesList;
  }

  onClickCreate(): void {
    this.showLoader = true;
    const saleOrders = this.theSelectedSaleOrders;
    const theSelectedSaleOrderIds = saleOrders.map((so) => so.id);
    if (
        !!saleOrders.find(
            (el) =>
                el.consolNumber !== null &&
                el.consolNumber !== undefined
        )
    ) {
        this.notify.showError(
            'Selected items contain sale order which included to Consol Shipment'
        );
        this.dialogRef.close();
        this.showLoader = false;
        return;
    }

    if (
        !!saleOrders.find(
            (el) =>
                el.status === SaleOrderStatus.NEW            
        ) && !!saleOrders.find(
            (el) =>
                el.status !== SaleOrderStatus.NEW            
        )
    ) {
        this.notify.showError(
            'Selected items contain sale order which do not have NEW status'
        );
        this.dialogRef.close();
        this.showLoader = false;
        return;
    }

    if (this.batchForm.valid) {
      const body = {
        'saleOrderIds' : theSelectedSaleOrderIds,
        'partnerId' : this.batchForm.value.partner,
        'countryOfOrigin' : this.batchForm.value.originCountry,
        'countryOfDestination' : this.batchForm.value.destinationCountry
      }
      this.batchService.createBatch(body).subscribe((res: any) => {
          this.showLoader = false;
          this.dialogRef.close(res);
      }, error => {
        this.showLoader = false;
        this.notify.showError(error.error ? error.error?.message : 'Something wrong');
        this.dialogRef.close();
      });
    } else {
      this.batchForm.markAllAsTouched();
    }
  }

  onClickClose(): void {
    this.dialogRef.close();
  }
}
